<template>
  <header class="main" ref="header" to="/home">
    <a href="/" class="title-wrap" @click.prevent="closePage" @keyup.enter.prevent="closePage">
      <h1 class="body-appear">Daniel Carter</h1>
      <h2 class="body-appear">Develops</h2>
    </a>
    <nav>
      <ul>
        <li>
          <a
            class="body-appear"
            href="/work"
            @click.prevent="goToWork"
            @keyup.enter.prevent="goToWork"
            :class="{'active':workActive}"
          >work</a>
        </li>
        <li>
          <a
            class="body-appear"
            href="/contact"
            @click.prevent="goToContact"
            @keyup.enter.prevent="goToContact"
            :class="{'active':contactActive}"
          >contact</a>
        </li>
        <li>
          <app-sun></app-sun>
        </li>
      </ul>
    </nav>
  </header>
</template>
<script>
import { eventBus, body } from "../main";
import Sun from "./svg/Sun.vue";
export default {
  data() {
    return {
      contactActive: false,
      workActive: false
    };
  },
  methods: {
    deactivateLinks() {
      this.workActive = false;
      this.contactActive = false;
    },
    closePage() {
      this.deactivateLinks();
      eventBus.$emit("closePage");
    },
    goToWork() {
      this.deactivateLinks();
      eventBus.$emit("goToWork");
      this.workActive = true;
    },
    goToContact() {
      this.deactivateLinks();
      eventBus.$emit("goToContact");
      this.contactActive = true;
    },
    checkRoute() {
      if (this.$route.path.includes("/work/")) {
        body.classList.add("about-page-opened");
      } else {
        body.classList.remove("about-page-opened");
      }
      if (this.$route.path.includes("work")) {
        this.workActive = true;
        this.contactActive = false;
        eventBus.$emit("pageIsOpen");
      } else if (this.$route.name === "contact") {
        this.contactActive = true;
        this.workActive = false;
        eventBus.$emit("pageIsOpen");
      } else {
        this.contactActive = false;
        this.workActive = false;
        eventBus.$emit("pageIsClosed");
      }
    }
  },
  components: {
    appSun: Sun
  },
  mounted() {
    eventBus.$on("routeChange", this.checkRoute);
    eventBus.$on("goToWorkFromSVG", this.goToWork);
    window.addEventListener("load", this.checkRoute);
  }
};
</script>
